import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
export function coordinateValidator(controlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {
      const numValue = parseFloat(value);

      if (controlName.includes("Latitude")) {
        return numValue >= -90 && numValue <= 90
          ? null
          : { invalidLatitude: true };
      }

      if (controlName.includes("Longitude")) {
        return numValue >= -180 && numValue <= 180
          ? null
          : { invalidLongitude: true };
      }
    }

    return null;
  };
}
